
import { create } from 'zustand';
import type { QuizState } from '@/types/quiz';

const initialQuizState: QuizState = {
  subject: null,
  selectedSubject: null,
  category: null,
  selectedCategory: null,
  view: "subject-selection",
  score: 0,
  language: 'en',
  streak: 0,
  questionIndex: 0,
  currentQuestionIndex: 0,
  answers: [],
  selectedAnswer: null,
  difficulty: 'medium',
  questionsCount: 20,
  completedQuestions: [],
  lastSessionId: null,
  showHint: false,
  currentHint: null,
  isLoading: false,
  selectedCategoryId: null,
  timeLeft: 0,
  darkMode: false,
  studyMode: false,
  practiceMode: false,
  learningPreferences: {
    dailyGoal: 10,
    preferredDifficulty: 'medium',
    focusSubjects: [],
    studyReminders: false,
    adaptiveLearning: true,
    spaceRepetition: true
  },
  adaptivePool: [],
  usedQuestionIds: []
};

export const useQuizState = create<{
  state: QuizState;
  setState: (state: QuizState | ((prev: QuizState) => QuizState)) => void;
  resetState: () => void;
  resetProgress: () => void;
  setSubject: (subject: string) => void;
  setCompletedQuestions: (questions: any[]) => void;
  setView: (view: string) => void;
  initialState: QuizState;
}>((set) => ({
  state: { ...initialQuizState },
  initialState: { ...initialQuizState },
  setState: (newState) => 
    set((prev) => ({ 
      state: typeof newState === 'function' 
        ? newState(prev.state) 
        : newState 
    })),
  resetState: () => set({ state: { ...initialQuizState } }),
  resetProgress: () => set((prev) => ({ 
    state: { 
      ...prev.state, 
      questionIndex: 0,
      score: 0,
      streak: 0,
      answers: [],
      completedQuestions: [],
      selectedAnswer: null,
      showHint: false,
      currentHint: null
    } 
  })),
  setSubject: (subject: string) => set((prev) => ({ 
    state: { 
      ...prev.state, 
      subject,
      selectedSubject: subject
    } 
  })),
  setCompletedQuestions: (questions) => set((prev) => ({ 
    state: { 
      ...prev.state, 
      completedQuestions: questions 
    } 
  })),
  setView: (view) => set((prev) => ({ 
    state: { 
      ...prev.state, 
      view 
    } 
  }))
}));
